<mat-drawer-container autosize>
  @let langSignalValue = languageService.langSignal();
  @let archiveActive = showArchive();
  <div id="top"></div>

  <div class="base-container">
    <div class="settings-button-stack">
      @if (isMasterUser()) {
        <button
          mat-mini-fab
          class="settings-button"
          tp="5 oder 6 Tage anzeigen"
          variation="popper"
          trigger="mouseenter"
          tpPlacement="left"
          (click)="onSwitchShowMoreDays()">
          @if (!showMoreDays()) {
            <fa-icon [icon]="['far', 'calendar-plus']" size="lg"></fa-icon>
          } @else {
            <fa-icon [icon]="['far', 'calendar-minus']" size="lg"></fa-icon>
          }
        </button>
      }

      <button
        mat-mini-fab
        class="settings-button"
        (click)="onSetupSettings()"
        tp="{{ 'HOME.SETTINGS' | translate }}"
        variation="popper"
        trigger="mouseenter"
        tpPlacement="left">
        <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon>
      </button>
      <button
        mat-mini-fab
        class="settings-button palette-toggle-button"
        [class.palette-toggle-button--active]="neutralColor() === 'green'"
        (click)="onToggleColor(neutralColor() !== 'green')"
        [matTooltip]="
          (neutralColor() === 'green'
            ? 'PRODUCT.EPP.SETTINGS.COLOR.GREEN'
            : 'PRODUCT.EPP.SETTINGS.COLOR.WHITE'
          ) | translate
        "
        tpPlacement="left">
        <fa-icon [icon]="['far', 'palette']" size="lg"></fa-icon>
      </button>
      @if (!archiveActive) {
        <button
          mat-mini-fab
          class="settings-button"
          tp="{{ 'PRODUCT.PIGEONS.SETTINGS.EPP.SHOW' | translate }}"
          variation="popper"
          trigger="mouseenter"
          tpPlacement="left"
          (click)="onScrollToCard('eppCard')">
          <fa-icon [icon]="['far', 'clouds-sun']" size="lg"></fa-icon>
        </button>
        <!--info button-->
        <button
          mat-mini-fab
          class="settings-button"
          tp="{{ 'PRODUCT.PIGEONS.SETTINGS.LEGEND' | translate }}"
          variation="popper"
          trigger="mouseenter"
          tpPlacement="left"
          (click)="onScrollToCard('legendCard')">
          <fa-icon [icon]="['far', 'info-circle']" size="lg"></fa-icon>
        </button>
      }
      <button
        mat-mini-fab
        class="settings-button"
        tp="{{ 'PRODUCT.PIGEONS.SETTINGS.VIDEO' | translate }}"
        variation="popper"
        trigger="mouseenter"
        tpPlacement="left"
        (click)="onToggleTutorialVideo()">
        <fa-icon [icon]="['far', 'video']" size="lg"></fa-icon>
      </button>

      <button
        mat-mini-fab
        class="settings-button"
        tp="{{ 'PRODUCT.PIGEONS.SETTINGS.PRINT' | translate }}"
        variation="popper"
        trigger="mouseenter"
        tpPlacement="left"
        (click)="onPrint()">
        <fa-icon [icon]="['far', 'print']" size="lg"></fa-icon>
      </button>
    </div>

    @if (showTutorialVideo()) {
      <app-pigeons-video (closeVideo)="onCloseTutorialVideo()">
      </app-pigeons-video>
    }

    @let selectedTimeValue = selectedTime();
    @let routePositionValue = routePosition();
    @let pigeonSpeedValue = pigeonSpeed();
    @let routesValue = routes();
    @let pigeonRouteDetailsValue = pigeonRouteDetails();
    @let selectedDayValue = selectedDay();
    @let showArchiveValue = showArchive();
    @let selectedStationIndexValue = selectedStationIndex();
    @let selectedStationValue = selectedStation();

    <!-- PANEL -->
    <form [formGroup]="individualRouteForm">
      <div class="panel">
        <!-- start input -->
        <mat-form-field appearance="fill" class="route-input">
          <mat-label>{{
            'PRODUCT.PIGEONS.ROUTESELECT.INDIVIDUAL.START' | translate
          }}</mat-label>
          <input
            type="text"
            #inputRouteStart
            formControlName="individualRouteStart"
            matInput
            [matAutocomplete]="autoCompleteStart"
            onfocus="allowAutoComplete = true; this.select()" />
        </mat-form-field>

        @let isStationSearchLoadingValue = isStationSearchLoading();
        <mat-autocomplete #autoCompleteStart="matAutocomplete">
          @if (isStationSearchLoadingValue) {
            <mat-option class="is-loading">
              <mat-spinner diameter="50"></mat-spinner>
            </mat-option>
          }
          @for (station of startStations$ | async; track $index) {
            <mat-option
              [value]="station.id + ' - ' + station.name"
              (onSelectionChange)="onStartStationSelect(station)">
              <span>{{ station.id }} – {{ station.name }}</span>
            </mat-option>
          }
        </mat-autocomplete>

        <button
          mat-icon-button
          (click)="onReverseRoute()"
          style="margin-right: 15px"
          type="button">
          <fa-icon
            [icon]="['far', 'arrow-right-arrow-left']"
            size="lg"></fa-icon>
        </button>

        <!-- end input -->
        <mat-form-field appearance="fill" class="route-input">
          <mat-label>{{
            'PRODUCT.PIGEONS.ROUTESELECT.INDIVIDUAL.END' | translate
          }}</mat-label>
          <input
            type="text"
            formControlName="individualRouteEnd"
            matInput
            [matAutocomplete]="autoCompleteEnd"
            onfocus="allowAutoComplete = true; this.select()" />
        </mat-form-field>

        <mat-autocomplete #autoCompleteEnd="matAutocomplete">
          @if (isStationSearchLoadingValue) {
            <mat-option class="is-loading">
              <mat-spinner diameter="50"></mat-spinner>
            </mat-option>
          }
          @for (station of endStations$ | async; track $index) {
            <mat-option
              [value]="station.id + ' - ' + station.name"
              (onSelectionChange)="onEndStationSelect(station)">
              <span>{{ station.id }} – {{ station.name }}</span>
            </mat-option>
          }
        </mat-autocomplete>

        <mat-form-field appearance="fill" class="route-select">
          <mat-label>{{
            'PRODUCT.PIGEONS.ROUTESELECT.STANDARD.SELECTROUTE' | translate
          }}</mat-label>
          <mat-select
            [(value)]="selectedRoute"
            (selectionChange)="onChangeRoute($event)">
            <mat-optgroup
              [label]="
                'PRODUCT.PIGEONS.ROUTESELECT.STANDARD.TITLE' | translate
              ">
              @for (route of routesValue; track $index; let i = $index) {
                <mat-option [value]="i">
                  {{ route.name }}
                </mat-option>
              }
            </mat-optgroup>
            <mat-optgroup
              [label]="
                'PRODUCT.PIGEONS.ROUTESELECT.INDIVIDUAL.TITLE' | translate
              ">
              <mat-option [value]="9999">{{
                'PRODUCT.PIGEONS.ROUTESELECT.INDIVIDUAL.TITLE' | translate
              }}</mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="speed-select">
          <mat-label>{{
            'PRODUCT.PIGEONS.ROUTESELECT.SPEED.SELECTSPEED' | translate
          }}</mat-label>
          <mat-select
            [(value)]="pigeonSpeed"
            (selectionChange)="onChangeSpeed($event)">
            <mat-option [value]="30">{{
              'PRODUCT.PIGEONS.ROUTESELECT.SPEED.SLOW' | translate
            }}</mat-option>
            @for (speed of pigeonSpeedLimits; track $index) {
              <mat-option [value]="speed"> {{ speed }} km/h </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button
          mat-icon-button
          class="help-button"
          [tp]="routeHelpPopup"
          variation="popper"
          trigger="mouseenter"
          tpPlacement="bottom">
          <fa-icon [icon]="['far', 'question-circle']" size="2x"></fa-icon>
        </button>
        <ng-template #routeHelpPopup>
          <h3>{{ 'PRODUCT.PIGEONS.HELP.ROUTESELECT.TITLE' | translate }}</h3>
          <p>{{ 'PRODUCT.PIGEONS.HELP.ROUTESELECT.TEXT' | translate }}</p>
        </ng-template>
        @if (outOfTimeScope()) {
          <button
            mat-icon-button
            class="warn-button"
            [tp]="outOfTimeSopePopup"
            variation="popper"
            trigger="mouseenter"
            tpPlacement="bottom">
            <fa-icon
              [icon]="['far', 'exclamation-triangle']"
              size="2x"></fa-icon>
          </button>
          <ng-template #outOfTimeSopePopup>
            <h3 style="color: #f23d3d">
              <fa-icon [icon]="['far', 'exclamation-triangle']"></fa-icon>
              &nbsp;{{ 'PRODUCT.PIGEONS.WARNING.TITLE' | translate }}
            </h3>
            <p>{{ 'PRODUCT.PIGEONS.WARNING.TEXT1' | translate }}</p>
            <p>{{ 'PRODUCT.PIGEONS.WARNING.TEXT2' | translate }}</p>
            <ol>
              <li>{{ 'PRODUCT.PIGEONS.WARNING.LIST1' | translate }}</li>
              <li>{{ 'PRODUCT.PIGEONS.WARNING.LIST2' | translate }}</li>
              <li>{{ 'PRODUCT.PIGEONS.WARNING.LIST3' | translate }}</li>
            </ol>
          </ng-template>
        }
      </div>
    </form>

    @if (
      pigeonRouteDetailsValue &&
      pigeonRouteDetailsValue.hasOwnProperty('stations')
    ) {
      <div class="flex-flow-wrapper-2">
        @let showValuesOnMapValue = showValuesOnMap();
        @let pigeonMosValue = pigeonMos();
        @let dtgIndexValue = dtgIndex();
        @let selectedArchiveDateValue = selectedArchiveDate();

        <mat-card
          appearance="outlined"
          class="pigeons-navigation-card"
          [class.archive-mode-active]="showArchiveValue">
          <!-- Der blinkende Indikator-Punkt am Rand der Karte -->
          @if (showArchiveValue) {
            <div class="archive-live-dot" [matTooltip]="'Archiv-Modus aktiv'">
              <span class="dot-core"></span>
              <span class="dot-pulse"></span>
              <span class="dot-text">Archive-Mode</span>
            </div>
          }

          @let stationIndexTimeValue = stationIndexTime();
          @let mapsTimeValue = mapsTime();

          <mat-card-header class="pigeons-nav-header">
            <div class="pigeons-nav-header-main">
              <mat-card-title>
                {{
                  selectedTimeValue
                    | dtgOfSelectedTimestep: mapsTimeValue
                    | datex: 'dd DD.MM.YYYY' : undefined : langSignalValue
                }}
                @let routeStartHourValue =
                  stationIndexTimeValue | routeStartHour;
                <span class="route-hour-bracket">(</span>
                <span [ngClass]="routeStartHourValue.class">
                  {{ routeStartHourValue.hour }}
                </span>
                @if (selectedDayValue | isNil: false) {
                  @let routeEndHourValue =
                    stationIndexTimeValue
                      | routeEndHour: pigeonRouteDetailsValue;
                  <span class="route-hour-dash">-</span>
                  <span [ngClass]="routeEndHourValue.class">
                    {{ routeEndHourValue.hour }}
                  </span>
                }
                <span class="route-hour-bracket">)</span>
              </mat-card-title>

              @if (pigeonRouteDetailsValue.stations.length > 1) {
                <mat-card-subtitle>
                  {{
                    pigeonRouteDetailsValue
                      | stationName
                        : (routePositionValue.hasOwnProperty('station')
                            ? routePositionValue['station']
                            : pigeonRoute().stations.start)
                  }}
                  -
                  {{
                    selectedTimeValue
                      | dtgOfSelectedTimestep: mapsTimeValue
                      | datex: 'HH:mm' : undefined : langSignalValue
                  }}
                </mat-card-subtitle>
              }
            </div>

            <div class="pigeons-nav-header-actions">
              <div class="action-controls-wrapper">
                <div
                  class="horizontal-slide-container"
                  [class.slide-open]="showArchiveValue">
                  <mat-form-field
                    appearance="fill"
                    subscriptSizing="dynamic"
                    (click)="picker.open()"
                    class="date-select pigeons-date-picker">
                    <mat-label>{{
                      'PRODUCT.PIGEONS.DATESELECT' | translate
                    }}</mat-label>
                    <input
                      matInput
                      [min]="minArchiveDate"
                      [max]="maxArchiveDate"
                      [formControl]="archiveDateControl"
                      [matDatepicker]="picker"
                      (dateChange)="onArchiveDateChange($event)" />
                    <mat-datepicker-toggle matIconSuffix [for]="picker">
                      <fa-icon
                        matDatepickerToggleIcon
                        [icon]="['far', 'calendar-alt']"
                        transform="up-1 shrink-2"
                        size="lg"></fa-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>

                <mat-slide-toggle
                  color="primary"
                  class="custom-color-switch pigeons-archive-switch"
                  [checked]="showArchiveValue"
                  (change)="onSetShowArchive($event)">
                  {{ 'PRODUCT.PIGEONS.Archive' | translate }}
                </mat-slide-toggle>

                <button
                  mat-icon-button
                  class="help-button inline-help"
                  [tp]="navigationHelpPopup"
                  variation="popper"
                  trigger="mouseenter"
                  tpPlacement="bottom">
                  <fa-icon
                    [icon]="['far', 'question-circle']"
                    size="lg"></fa-icon>
                </button>

                <ng-template #navigationHelpPopup>
                  <h3>{{ 'PRODUCT.PIGEONS.HELP.MATRIX.TITLE' | translate }}</h3>
                  <p>{{ 'PRODUCT.PIGEONS.HELP.MATRIX.TEXT1' | translate }}</p>
                  <p>{{ 'PRODUCT.PIGEONS.HELP.MATRIX.TEXT2' | translate }}</p>
                  <p>{{ 'PRODUCT.PIGEONS.HELP.MATRIX.TEXT3' | translate }}</p>
                  <p>{{ 'PRODUCT.PIGEONS.HELP.MATRIX.TEXT4' | translate }}</p>
                  <p>{{ 'PRODUCT.PIGEONS.HELP.MATRIX.TEXT5' | translate }}</p>
                  <p>{{ 'PRODUCT.PIGEONS.HELP.MATRIX.TEXT6' | translate }}</p>
                </ng-template>
              </div>
            </div>
          </mat-card-header>

          <!-- Navigationstabs für die Tage -->
          <nav
            mat-tab-nav-bar
            class="day-nav pigeons-day-tabs"
            [tabPanel]="dayNavTabPanel">
            @for (day of days(); track $index) {
              <a
                mat-tab-link
                (click)="onSelectDay(day)"
                [active]="selectedDayValue === day">
                {{
                  day
                    | datex
                      : (showArchiveValue ? 'dd DD.MM.' : 'dd')
                      : undefined
                      : langSignalValue
                }}
              </a>
            }
          </nav>
          <mat-tab-nav-panel #dayNavTabPanel> </mat-tab-nav-panel>

          <!-- Matrix-Inhalt -->
          @let timeStepsValue = timeSteps();
          @if (
            selectedDayValue &&
            pigeonRouteDetailsValue.stations.length > 0 &&
            timeStepsValue.length > 0 &&
            (pigeonMos() | keyvalue).length > 0
          ) {
            <div class="pigeons-matrix-wrapper">
              <app-pigeons-matrix
                [timeSteps]="timeStepsValue"
                [selectedTimeStep]="selectedTime()"
                [stations]="pigeonRouteDetailsValue.stations"
                [mosData]="pigeonMos()"
                [dtgIndex]="dtgIndex()"
                [day]="selectedDayValue"
                [stationTime]="stationIndexTime()"
                [selectedStation]="selectedStation()"
                [selectedStationIndex]="selectedStationIndex()"
                [modelRun]="selectedArchiveDate()"
                (matrixClick)="onMatrixSelectionChange($event)">
              </app-pigeons-matrix>
            </div>
          }
        </mat-card>

        <mat-card appearance="outlined" class="pigeons-map-card">
          @let selectedParameterValue = selectedParameter();
          <mat-card-header>
            <mat-card-title>{{
              'PRODUCT.PIGEONS.PARAMETER.' + selectedParameterValue | translate
            }}</mat-card-title>
            @if (pigeonRouteDetailsValue.distance > 0) {
              <mat-card-subtitle>
                {{ 'PRODUCT.PIGEONS.MAP.DISTANCE' | translate }}:
                {{ pigeonRouteDetailsValue.distance }} km -
                {{ 'PRODUCT.PIGEONS.MAP.DURATION' | translate }}:
                {{ pigeonRouteDetailsValue.duration | round }} h -
                {{ 'PRODUCT.PIGEONS.MAP.SPEED' | translate }}:
                {{ pigeonSpeedValue }} km/h
              </mat-card-subtitle>
            }
            <fa-icon
              mat-card-avatar
              [icon]="['far', parameters[selectedParameterValue]['icon']]"
              size="2x"></fa-icon>
            <button
              mat-icon-button
              class="show-values-button"
              matTooltip="Umgebungswerte anzeigen/ausblenden"
              [ngClass]="
                showValuesOnMapValue
                  ? 'show-values-button-active'
                  : 'show-values-button-inactive'
              "
              (click)="showValuesOnMap.set(!showValuesOnMapValue)">
              <fa-icon [icon]="['far', 'braille']" size="2x"></fa-icon>
            </button>
            <button
              mat-icon-button
              class="close-button"
              [tp]="mapHelpPopup"
              variation="popper"
              trigger="mouseenter"
              tpPlacement="bottom">
              <fa-icon [icon]="['far', 'question-circle']" size="2x"></fa-icon>
            </button>
            <ng-template #mapHelpPopup>
              <h3>{{ 'PRODUCT.PIGEONS.HELP.MAP.TITLE' | translate }}</h3>
              <p>{{ 'PRODUCT.PIGEONS.HELP.MAP.TEXT1' | translate }}</p>
              <p>{{ 'PRODUCT.PIGEONS.HELP.MAP.TEXT2' | translate }}</p>
              <ul>
                <li class="red-circle">
                  {{ 'PRODUCT.PIGEONS.HELP.MAP.TEXT3' | translate }}
                </li>
                <li class="blue-circle">
                  {{ 'PRODUCT.PIGEONS.HELP.MAP.TEXT4' | translate }}
                </li>
              </ul>
            </ng-template>
          </mat-card-header>

          <nav
            mat-tab-nav-bar
            class="parameter-nav"
            [tabPanel]="parameterNavTabPanel">
            @for (parameter of parameters | key; track $index) {
              <a
                mat-tab-link
                (click)="onParameterSelect(parameter)"
                [tp]="'PRODUCT.PIGEONS.PARAMETER.' + parameter | translate"
                [active]="selectedParameterValue === parameter">
                <fa-icon
                  [icon]="[
                    selectedParameterValue === parameter ? 'fas' : 'far',
                    parameters[parameter]['icon'],
                  ]"
                  size="lg"></fa-icon>
              </a>
            }
          </nav>
          <mat-tab-nav-panel #parameterNavTabPanel> </mat-tab-nav-panel>

          <!-- container for printing pigeons-map as image  -->
          <div class="print-map-image-container">
            <img
              #placeholderImageForPigeonMap
              alt="map image"
              src="data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" />

            <!-- map source logos -->
            <div class="print-mapboxlogo-container mapboxgl-map">
              <a
                class="mapboxgl-ctrl-logo"
                target="_blank"
                rel="noopener nofollow"
                href="https://www.mapbox.com/"
                aria-label="Mapbox logo"></a>
              <div class="mapboxgl-ctrl-bottom-right">
                <div class="mapboxgl-ctrl mapboxgl-ctrl-attrib">
                  <button
                    class="mapboxgl-ctrl-attrib-button"
                    type="button"
                    aria-label="Toggle attribution">
                    <span
                      class="mapboxgl-ctrl-icon"
                      aria-hidden="true"
                      title="Toggle attribution"></span>
                  </button>
                  <div class="mapboxgl-ctrl-attrib-inner" role="list">
                    <a
                      href="https://www.mapbox.com/about/maps/"
                      target="_blank"
                      title="Mapbox"
                      aria-label="Mapbox"
                      role="listitem"
                      >© Mapbox</a
                    >
                    <a
                      href="https://www.openstreetmap.org/about/"
                      target="_blank"
                      title="OpenStreetMap"
                      aria-label="OpenStreetMap"
                      role="listitem"
                      >© OpenStreetMap</a
                    >
                    <a
                      class="mapbox-improve-map"
                      href="https://apps.mapbox.com/feedback/?owner=connybruhn&amp;id=ckcyi11261klk1iqvvrqowu4b&amp;access_token=pk.eyJ1IjoiY29ubnlicnVobiIsImEiOiJjanBqaHU2aWMwNmY0M3FsdjVyaXo0N21lIn0.wOrequAwl4sj8xvEzP5_6A"
                      target="_blank"
                      title="Improve this map"
                      aria-label="Map feedback"
                      role="listitem"
                      rel="noopener nofollow"
                      >Improve this map</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          @let dtgsValue = dtgs();
          @if (selectedParameterValue && dtgsValue.length > 0) {
            <app-map
              class="aspect-ratio-container"
              [region]="'de'"
              [mapType]="mapType.PIGEONS"
              [parameter]="selectedParameterValue"
              [dtgIndex]="dtgIndexValue"
              [dtgs]="dtgsValue"
              [pigeonRoute]="routesValue[selectedRoute()]"
              [pigeonRouteDetails]="pigeonRouteDetailsValue"
              [pigeonMos]="pigeonMosValue"
              [pigeonRoutePosition]="routePositionValue"
              [pigeonStationTime]="stationTime()"
              [pigeonShowTileAround]="showValuesOnMapValue"
              [pigeonModelRun]="selectedArchiveDateValue"
              (pigeonPositionChange)="onMapPositionChange($event)"
              (pigeonStartChange)="onMapStartChange($event)"
              (pigeonEndChange)="onMapEndChange($event)"
              (pigeonHourChange)="onMapHourChange($event)"
              (pigeonParameterChange)="onParameterSelect($event)"></app-map>
          }
        </mat-card>
      </div>
    }

    <!-- EPP CARD -->
    @if (!showArchiveValue) {
      <mat-card appearance="outlined" class="pigeon-epp-card" id="eppCard">
        <mat-card-header>
          <mat-card-title>
            {{ 'PRODUCT.PIGEONS.EPP.TITLE' | translate }}
            {{
              selectedDayValue
                | datex: 'dddd, DD.MM.yyyy' : undefined : langSignalValue
            }}
          </mat-card-title>
          @if (
            pigeonRouteDetailsValue.stations.length > 0 &&
            (selectedStationIndexValue | isNil: false)
          ) {
            <mat-card-subtitle>
              {{
                pigeonRouteDetailsValue.stations[selectedStationIndexValue].name
              }}
              <span style="margin-left: 10px">
                @let sunTimesValue =
                  selectedStationValue
                    | suntimes
                      : selectedDayValue
                      : sunTimesArray()
                      : selectedStationIndexValue
                      : pigeonRouteDetailsValue;
                <fa-icon [icon]="['far', 'sunrise']"></fa-icon>
                {{ sunTimesValue.sunrise }} &nbsp;
                <fa-icon [icon]="['far', 'sunset']"></fa-icon>
                {{ sunTimesValue.sunset }}
              </span>
            </mat-card-subtitle>
          }
          <fa-icon
            mat-card-avatar
            [icon]="['far', 'clouds-sun']"
            size="2x"></fa-icon>
          <button
            class="btn-top"
            mat-icon-button
            color="primary"
            (click)="onClickScroll('top')">
            <fa-icon [icon]="['far', 'chevron-up']"></fa-icon>
          </button>

          <mat-form-field appearance="fill" class="epp-station-select">
            <mat-label>{{
              'PRODUCT.PIGEONS.EPP.STATIONSELECT' | translate
            }}</mat-label>
            @let pigeonStations = pigeonRouteDetailsValue.stations;

            <mat-select
              [(value)]="selectedStation"
              (selectionChange)="onChangeStation($event)">
              @for (station of pigeonStations; track $index; let i = $index) {
                <mat-option [value]="station.stationId">
                  {{ station.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @let eppForecastDtgValue = eppForecastDtg();
          @if (eppForecastDtgValue) {
            <span style="margin-top: 8px; margin-left: 15px">
              {{ 'PRODUCT.EPP.LAST_UPDATE' | translate }}
              {{
                eppForecastDtgValue
                  | datex: 'HH:mm' : undefined : langSignalValue
              }}
            </span>
          }

          <button
            mat-icon-button
            style="margin-left: 15px"
            aria-label="Refresh data"
            (click)="onRefreshEppData()">
            <mat-icon>refresh</mat-icon>
          </button>
        </mat-card-header>
        @if (selectedStationValue) {
          <div></div>
          @if (pigeonsService | isNil: false) {
            <app-pigeons-epp
              [parameterset]="pigeonsService.parameterset"
              [parameterDefinitions]="
                pigeonsService.defaultParametersetDetails[
                  pigeonsService.parameterset
                ]
              "
              [hour]="selectedTimeValue"
              [userParameters]="
                pigeonsService.userParametersets[pigeonsService.parameterset]
              "
              [stationId]="selectedStationValue"
              [day]="selectedDayValue"
              (forecastDtg)="onGetEppDtg($event)">
            </app-pigeons-epp>
          }
        }
      </mat-card>
    }

    <!-- LEGEND CARD-->
    @if (!showArchiveValue) {
      <app-pigeons-legend id="legendCard" (scrollToTop)="onClickScroll('top')">
      </app-pigeons-legend>
    }
  </div>

  <!-- DRAWER FOR SETTINGS -->
  <mat-drawer #drawer class="settings-sidenav" mode="over" position="end">
    <button mat-icon-button class="close-button" (click)="drawer.toggle()">
      <fa-icon [icon]="['far', 'times']"></fa-icon>
    </button>

    <app-pigeons-settings
      [parameterSets]="[pigeonsService.parameterset ?? 'pigeon']"
      [selectedParameterSet]="settingsParameterset()"
      [settingsParameters]="settingsParameters()"
      [showMoreDays]="showMoreDays()"
      [isUserMaster]="isMasterUser()"
      (toggleTutorialVideo)="onToggleTutorialVideo()"
      (scrollToLegendCard)="onClickScroll($event)"
      (openDrawer)="onOpenDrawer($event)"
      (moreDays)="onSwitchShowMoreDays()"
      (print)="onPrint()"
      (restoreStandardSettings)="onRestoreStandardSettings()"
      (cancelSettings)="drawer.toggle()"
      (saveSettings)="onSaveSettings()"
      (parameterSelectionChange)="onParameterSelectionChange($event)"
      (drop)="onDrop($event)"
      (selectAllChange)="toggleAllParameters($event)">
    </app-pigeons-settings>
  </mat-drawer>
</mat-drawer-container>
